<template>
  <div class="mobileEndStyle">
    <mobilePlugin ref="plugin" @openImg="openImg"></mobilePlugin>

    <div class="homePageBackground">
      <!--轮播图-->
      <div class="index_lunbobanner">
        <img class="aaa" src="../assets/image/banner.jpg" />
      </div>
      <!--课程分类-->

      <div class="pts_dk" @mouseleave="professionalGroupIsDisplayed = false, trainingStyle = -1">
        <div class="index_pts_kcfl_bottom">
          <img src="../assets/image/beauty.png" ref="beautyRef" class="mp-img" v-show="imgShow" @click="switchGif" />
          <div class="payTheDesignedOnTheLeftSideOfThe">
            <div class="inTheLeftNavigation">
              <span class="alternatingHeaderImages">
                <img src="../assets/image/jiaozhuan_09.png.png" alt="" /></span>
              <span class="handInHeadline">道路与桥梁工程技术专业群</span>
              <span class="daosj"></span>
            </div>
            <div class="designedNavigationContent">
              <ul>
                <li :class="{ active: trainingStyle === index }" v-for="(item, index) in professionalGroupOfData"
                  :key="index" @mouseenter="trainingClick(item.id, index)">
                  <div class="theBottomWidth">
                    <span class="theSimulation"></span> {{ item.deptName }}
                    <!--clickTheLeftNavigation-->
                    <span class="liBehindAVerticalBar" v-show="trainingStyle == index"></span>
                  </div>
                </li>
              </ul>
            </div>
          </div>



          <div class="designOfTheLower" v-show="professionalGroupIsDisplayed">
            <!-- <div class="closeIcon" @click="professionalGroupIsDisplayed = false ,trainingStyle=-1">
              <i class="iconfont icon-guanbi"></i>
            </div> -->
            <div class="space">


              <div class="trainingCenterBigBox" v-for="(item, index) in professionalGroupOfTrainingData" :key="index"
                @click="professionalGroupOfClickJump(item.id, index)">
                <div class="onTheLeftSideOfTheTrainingCenter">
                  {{ item.label }}

                </div>
                <div class="theArrow">＞</div>

                <div class="trainingCentreOnTheRightSide">
                  <ul>
                    <li v-for="(items, indexs) in professionalGroupOfTrainingData[index].children" :key="indexs"
                      @click="professionalGroupOfClickJump(item.id, index, indexs)">
                      {{ items.label }}
                    </li>
                  </ul>
                </div>

              </div>






            </div>
          </div>
          <div class="paySpecialRight" v-show="!professionalGroupIsDisplayed">
            <div class="recommendThe">推荐实验</div>
            <div class="recommendedExperiment">
              <ul>
                <li v-for="(item, index) in theExperimentalData" v-show="index<1" :key="index"  @click="clickOnThe(item.id)">
                  <div class="aListOfImages">
                    <img
                      onerror="this.src='data:image/jpeg;base64,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'"
                      :src="imagePath(item.cover)" alt="" />
                  </div>
                  <div class="paySpecialTitle">
                    {{ item.courseName }}
                  </div>
                  <div class="paySpecialTeacher">主讲教师：{{ item.teacherName }}</div>
                </li>
              </ul>
            </div>


            <div class="theExperimentalRecommendationIsAsFollows">
              <ul>
                <li v-for="(item, index) in theExperimentalData" :key="index" @click="clickOnThe(item.id)">
                  <div class="aListOfImages">
                    <img
                      onerror="this.src='data:image/jpeg;base64,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'"
                      :src="imagePath(item.cover)" alt="" />
                  </div>
                  <div class="paySpecialTitle">
                    {{ item.courseName }}
                  </div>
                  <div class="paySpecialTeacher">主讲教师：{{ item.teacherName }}</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="index_pts_kcfl_right">
          <div class="right_top">
            <div class="pts_right_zxdt">通知公告</div>
            <ul class="zxdt_right_title">
              <li v-for="(item, index) in tableData" :key="index" @click="clickOnTheAnnouncements(item.id)">
                <!--@click="informationClickOnThe(item.id)"-->
                <span class="theInformationTime">[{{ time(item.createTime) }}]</span><span prop="projectName">{{
                    item.title
                }}</span>
              </li>
            </ul>
          </div>
          <div class="right_bottom">
            <div class="pts_right_zxdt">最新资讯</div>
            <!-- <ul class="right_bottom_title">
              <li class="active_xhx">
                <a class="" @click="msg = 0" :class="{ zxactive: msg === 0 }">最新资讯</a>
              </li>
              <span class="topBorder"></span>
              <li>
                <a class="" @click="theLatestHomePageRanking((msg = 1))" :class="{ zxactive: msg === 1 }">最新排行</a>
              </li>
            </ul> -->
            <!-- <div class="bottom_xhx"></div> -->

            <ul class="bottom_content">
              <!--v-show="msg === 0"-->
              <li v-for="(item, index) in tableDatas" :key="index" v-show="index < 10"
                @click="clickOnTheAnnouncements(item.id)">
                <!-- @click="clickOnTheCourse(item.id)"-->
                <div class="bonttom_titlede">
                  <div class="bottom_bh bottom_active">

                  </div>
                  {{ item.title }}
                </div>
                <div class="bottom_cpxs">
                  <div class="cpxs_left_img">
                    <img :src="imagePath(item.coverImage)" />
                  </div>
                  <div class="cpxs_right_text">
                    <span>{{ item.description }} <span class="detailsAboutTheColor">[详情]</span> </span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import { ref, reactive, onMounted } from "vue";
import mobilePlugin from "./mobilePlugin.vue";
import {
  professionalGroupOf,
  theHomepageExperiment,
  announcements,
  groupOfProfessionalTraining,
  theLatestInformation,
  getVoiceServerUrl,
} from "../assets/api/index";
import router from "../router/index.js";
import imagePath from "../assets/js/config.js";
import { getCurrentInstance } from "@vue/runtime-core";
import Recorder from 'recorder-core'
import 'recorder-core/src/engine/pcm'
import 'recorder-core/src/extensions/buffer_stream.player.js'
export default {
  components: {
    mobilePlugin,
  },
  setup() {
    const { proxy } = getCurrentInstance();
    const imgShow = ref(true);

    //专业群
    const professionalGroupOfData = ref([]);
    const professionalGroupOfAccess = () => {
      professionalGroupOf().then((res) => {
        professionalGroupOfData.value = res.data[0].sysNavigationList;
      });
    };
    professionalGroupOfAccess();

    //首页实验
    const theExperimentalData = ref([]);
    const theExperimentRequest = () => {
      theHomepageExperiment().then((res) => {
        theExperimentalData.value = res.rows;
      });
    };
    theExperimentRequest();

    //点击实验

    const clickOnThe = (value) => {
      router.push({ path: "projectDetails", query: { theId: value } });
    };

    //通知公告
    const tableData = ref([]);
    const tableDatas = ref([]);
    const theNotificationRequest = reactive({
      type: null,
    });
    const informTheData = (value) => {
      theNotificationRequest.type = value;
      announcements(theNotificationRequest).then((res) => {
        if (value == "0") {
          tableData.value = res.data;
        } else {
          tableDatas.value = res.data;
        }
      });
    };
    const time = (value) => {
      return value.substr(0, 10);
    };
    informTheData("0");
    informTheData("1");

    //专业群实验数据
    const trainingClickOnTheRequest = reactive({
      ancestors: null,
    });
    const professionalGroupIsDisplayed = ref(false);
    const professionalGroupOfTrainingData = ref([]);
    const professionalGroupOfTrainingDatachildren = ref([]);
    const professionalTrainingBegan = () => {
      groupOfProfessionalTraining(trainingClickOnTheRequest).then((res) => {
        professionalGroupOfTrainingData.value = res.navigations;
        // resnavigations.forEach(item => {
        //   ceshi.push(item.children);
        // });
        professionalGroupIsDisplayed.value = true;
      });
    };

    //专业群三级分类点击
    const professionalGroupOfStorage = ref([]);
    const professionalGroupOfStorages = ref([0]);
    const professionalGroupOfClickJump = (value, index, indexs) => {
      router.push({ path: "theListOf", query: { roadId: professionalGroupOfStorage.value, roadIds: index, roadIdsr: indexs } });
    };

    //专业群触碰点击
    const trainingStyle = ref();
    const trainingClick = (value, index) => {
      professionalGroupOfStorage.value = index;



      trainingStyle.value = index;
      trainingClickOnTheRequest.ancestors = value;
      professionalTrainingBegan();
    };

    //点击通知公告

    const clickOnTheAnnouncements = (value) => {
      router.push({ path: "informationForDetails", query: { newsid: value } });
    };

    const beautyRef = ref(null)
    const beauty = ref({})
    onMounted(() => {
      beauty.value = beautyRef.value
      console.log(beauty.value)
    });

    window.onscroll = function () {
      //变量scrollTop是滚动条滚动时，距离顶部的距离
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      //变量windowHeight是可视区的高度
      var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
      //变量scrollHeight是滚动条的总高度
      var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      //写后台加载数据的函数
      console.log("距顶部" + scrollTop + "可视区高度" + windowHeight + "滚动条总高度" + scrollHeight);
      console.log(scrollHeight - scrollTop - windowHeight - 233);
      let bHeight = scrollHeight - scrollTop - windowHeight - 233
      if (bHeight <= 0) {
        beauty.value.style.bottom = 0 - bHeight + 'px'
        plugin.value.switchBottom(false, bHeight)
      } else {
        beauty.value.style.bottom = '0px'
        plugin.value.switchBottom(true, 0)
      }
    }

    const wsUrl = ref('')
    const duration = ref(0)
    const powerLevel = ref(0)
    const sampleRate = ref(8000)
    const rec = ref(0)
    const realTimeSendTryChunk = ref(null)
    const ws = ref(null)
    const stream = ref(null)
    const allowPlayback = ref(true)
    const realTimeSendTryTime = ref('')

    const plugin = ref();
    const switchGif = () => {
      duration.value = 0
      rec.value = 0
      ws.value = null
      realTimeSendTryChunk.value = null
      realTimeSendTryTime.value = 0
      stream.value = null
      VoiceServerUrl();
      plugin.value.switchDiagram();
      imgShow.value = false;
    };

    const openImg = () => {
      ws.value.close()
      rec.value.close()
      imgShow.value = true;
    };

    const play = () => {
      var testType, testDecode, testTransform;
      var startPcm = function () {
        testType = "pcm";
        testDecode = false; //pcm无需解码，但必须将输入转换成pcm[Int16,...]
        testTransform = function (arrayBuffer, sampleRate, True) {
          //pcm需指定sampleRate，为传输过来pcm的采样率
          True(new Int16Array(arrayBuffer), sampleRate);
        };
        start();
      };

      var start = function () {
        stream.value = Recorder.BufferStreamPlayer({
          decode: testDecode, //传输过来的不是pcm就需要开启解码
          onInputError: function (errMsg, inputIndex) {
            console.log("第" + inputIndex + "次的音频片段input输入出错: " + errMsg, 1);
          },
          onPlayEnd: function () {
            if (!stream.value.isStop) {
              plugin.value.imgInit();
            }
          },
          transform: function (pcm, sampleRate, True, False) {
            testTransform(pcm, sampleRate, function (pcm, sampleRate) {
              True(pcm, sampleRate);
            }, False);
          },
          realtime: false,
          sampleRate: sampleRate.value
        });

        stream.value.start(function () {
          console.log("音频流已打开[" + testType + "]，正在播放中", 2);
        }, function (err) {
          console.log("开始失败：" + err, 1);
        });
      };
      //实时的接收到了音频片段文件，通过input方法输入到流里面
      var receiveAudioChunk = function (arrayBuffer) {
        if (stream.value) {
          stream.value.input(arrayBuffer);
        }
      };
      return {
        receiveAudioChunk,
        startPcm
      }
    }
    const VoiceServerUrl = () => {
      getVoiceServerUrl({ robotId: 'robot_155' }).then(res => {
        console.info(res)
        wsUrl.value = res.data
        recStart()
      })
    }
    // VoiceServerUrl();



    const recStart = () => {
      // 可能会导致错误的代码
      var recV = rec.value = Recorder({
        type: "unknown",
        onProcess: function (buffers, powerLevel, bufferDuration) {
          try {
            duration.value = bufferDuration;
            powerLevel = powerLevel;
            common().RealTimeSendTry(recV, false); //推入实时处理，因为是unknown格式，这里简化函数调用，没有用到buffers和bufferSampleRate，因为这些数据和rec.buffers是完全相同的。
          } catch (error) {
            // 错误发生时如何处理
            console.info(error)
          } finally {
            // 无论 成功还是失败都会执行的处理
          }
        }
      });
      recV.open(function () { //打开麦克风授权获得相关资源
        recV.start(); //开始录音
        openWebSocket();
        common().RealTimeSendTryReset('pcm'); //重置
      }, function () {
      });
    }

    const recStop = () => {
      rec.value.close();
      common().RealTimeSendTry(rec.value, true); //最后一次发送
      realTimeSendTryChunk.value = null;
    }

    const openWebSocket = () => {
      ws.value = new WebSocket(wsUrl.value + "&mediaType=audio,action,text,control");
      ws.value.binaryType = 'arraybuffer'; //传输的是 ArrayBuffer 类型的数据
      ws.value.onopen = () => {
        if (ws.value.readyState === 1) {
          play().startPcm();
        }
      };

      ws.value.onmessage = (msg) => {
        if (msg.data instanceof ArrayBuffer) {
          if (allowPlayback.value) {
            play().receiveAudioChunk(msg.data);
          }
          return
        }
        let result = JSON.parse(msg.data)
        console.log(result)
        if (result.type === 'action') {
          let resultData = JSON.parse(result.data)
          if (resultData && resultData.length > 0) {
            let actionFileUrl = resultData[0].actionContent
            console.info(resultData[0])
            plugin.value.imgInit(actionFileUrl);
            plugin.value.actionReception(actionFileUrl, resultData[0].endTimeSeconds);
          }
        } else if (result.type === 'default') {
          let resultData = JSON.parse(result.data)
          if (resultData && resultData.length > 0) {
            let actionFileUrl = resultData[0].actionContent
            plugin.value.imgInit(actionFileUrl);
          }
        }
      }
      ws.value.onerror = (err) => {
        console.error(err)
        recStop();
      }
    }

    const common = () => {
      var testSampleRate = 8000;
      var SendInterval = 300;
      //重置环境
      var RealTimeSendTryReset = function (type) {
        console.log('重制麦克风环境')
        realTimeSendTryType = type;
        realTimeSendTryTime.value = 0;
      };

      var realTimeSendTryType;
      var realTimeSendTryEncBusy;
      var realTimeSendTryNumber;
      var transferUploadNumberMax;

      //=====实时处理核心函数==========
      var RealTimeSendTry = function (rec, isClose) {
        var t1 = Date.now();
        if (realTimeSendTryTime.value === 0) {
          realTimeSendTryTime.value = t1;
          realTimeSendTryEncBusy = 0;
          realTimeSendTryNumber = 0;
          transferUploadNumberMax = 0;
          realTimeSendTryChunk.value = null;
        }
        if (!isClose && t1 - realTimeSendTryTime.value < SendInterval) {
          return; //控制缓冲达到指定间隔才进行传输
        }

        realTimeSendTryTime.value = t1;
        var number = ++realTimeSendTryNumber;
        //借用SampleData函数进行数据的连续处理，采样率转换是顺带的
        var chunk = Recorder.SampleData(rec.buffers, rec.srcSampleRate, testSampleRate, realTimeSendTryChunk.value, {
          frameType: isClose ? "" : realTimeSendTryType
        });
        //清理已处理完的缓冲数据，释放内存以支持长时间录音，最后完成录音时不能调用stop，因为数据已经被清掉了
        for (var i = realTimeSendTryChunk.value ? realTimeSendTryChunk.value.index : 0; i < chunk.index; i++) {
          rec.buffers[i] = null;
        }
        realTimeSendTryChunk.value = chunk; //此时的chunk.data就是原始的音频pcm数据，直接保存即为pcm文件、加个wav头即为wav文件、丢给mp3编码器转一下码即为mp3文件

        //没有新数据，或结束时的数据量太小，不能进行mock转码
        if (chunk.data.length === 0 || isClose && chunk.data.length < 2000) {
          console.log('没有新数据，或结束时的数据量太小，不能进行mock转码')
          TransferUpload(number, null, 0, null, isClose);
          return;
        }

        //实时编码队列阻塞处理
        if (!isClose) {
          if (realTimeSendTryEncBusy >= 2) {
            console.log('编码队列阻塞，已丢弃一帧')
            return;
          }
        }
        realTimeSendTryEncBusy++;
        TransferUpload(number, chunk.data, 0, null, isClose);
      };

      //=====数据传输函数==========
      var TransferUpload = function (number, blobOrNull) {
        transferUploadNumberMax = Math.max(transferUploadNumberMax, number);
        if (blobOrNull) {
          blobOrNull = new Blob([blobOrNull])
          var blob = blobOrNull;
          if (ws.value && ws.value.readyState === 1) {
            ws.value.send(blob);
          }
        }
      };
      return {
        RealTimeSendTry,
        RealTimeSendTryReset
      }
    }


    return {
      imagePath,
      //最新资讯
      theNotificationRequest,
      //专业群获取
      professionalGroupOfAccess,
      professionalGroupOfData,
      professionalTrainingBegan,
      professionalGroupOfTrainingData,
      professionalGroupOfTrainingDatachildren,
      trainingClickOnTheRequest,
      professionalGroupIsDisplayed,
      trainingClick,
      trainingStyle,
      professionalGroupOfClickJump,
      //首页实验
      theExperimentalData,
      theExperimentRequest,
      professionalGroupOfStorage,
      professionalGroupOfStorages,
      //点击实验
      clickOnThe,
      //通知公告
      tableData,
      tableDatas,
      informTheData,
      time,
      switchGif,
      imgShow,
      openImg,
      plugin,
      clickOnTheAnnouncements,
      beautyRef,
      VoiceServerUrl,
    };
  }, beforeCreate() {

    document.querySelector('html').setAttribute('style', 'background:#FFF')
  },

  name: "HelloWorld",
};
</script>

<style scoped>
#app {
  background: #fff !important;
}

.homePageProjectPictures {
  height: 152px !important;
}

.onTheLeftSideOfThePicture {
  display: block;
  width: 21px;
  float: left;
  height: 20px;
  margin-right: 6px;
  position: relative;
  top: 3px;
}

.aaa {
  /* width: 100%; */

  text-align: center;
  display: block;
}

/**主页新加 */

.payTheDesignedOnTheLeftSideOfThe {
  width: 240px;
  min-height: 0;
  float: left;

}

.inTheLeftNavigation {
  width: 240px;
  height: 48px;
  background: #e0e0e0;
  line-height: 48px;
  text-align: center;
}

.alternatingHeaderImages {
  position: relative;
  top: 10px;
}

.handInHeadline {
  font-size: 15px;
  margin-left: 5px;
  font-weight: 600;
}

.designedNavigationContent {
  background: #eeeeee;
  margin-top: 13px;

}

.designedNavigationContent ul li {
  height: 49px;

  line-height: 48px;
  position: relative;
  cursor: pointer;
  overflow: hidden;
  width: 240px;
}

.designedNavigationContent ul {
  width: 100%;
  /* margin: 0 auto; */
  /* margin-left: 20px; */
  text-indent: 20px;
  padding-top: 10px;
}

.paySpecialRight {
  float: right;
  margin-left: 20px;
}

.paySpecialRight ul li {
  width: 220px;
  float: left;
  margin-right: 11px;
  margin-bottom: 20px;
}

.aListOfImages {
  width: 100%;
  height: 144px;
}

.aListOfImages img {
  width: 100%;
  height: 100%;
}

.paySpecialTitle {
  font-size: 14px;
  margin-top: 10px;
}

.paySpecialTeacher {
  font-size: 14px;
  color: #999999;
  margin-top: 12px;
}

.theSimulation {
  width: 5px;
  height: 5px;
  background: #ca1c1d;
  display: inline-block;
  position: relative;
  bottom: 3px;
  margin-right: 0px;
  margin-left: -19px;
}

.daosj {
  width: 0px;
  height: 0px;
  border: 13px solid transparent;
  border-top-color: #e0e0e0;
  display: inline-block;
  position: relative;
  bottom: 7px;
}

.clickTheLeftNavigation {
  color: red;
}

.theInformationTime {
  color: #777;
  font-size: 12px !important;
}

/**弹出 */

.designOfTheLower {
  width: 696px;
  top: 0;
  left: 241px;
  background: #fff;
  /* min-height: 500px; */
  padding-bottom: 40px;
  box-shadow: 0px 4px 11px -8px rgba(0, 0, 0, 0.75);
  -webkit-box-shadow: 0px 4px 11px -8px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 4px 11px -8px rgba(0, 0, 0, 0.75);
  height: 410px;

}

.routeDesign {
  float: left;
  margin-right: 50px;
}

.designOfTheLower table tr {
  height: 76px;
  margin-bottom: 1px;
  display: inline-block;
  width: 100%;
  margin-top: 20px;
}

.designOfTheLower table tr th {
  font-size: 14px;
  width: 240px;
}

.designOfTheLower table tr td {
  padding-top: 19px;
  line-height: 34px;
}

.routeDesign {
  margin-bottom: 0;
}

.liBehindAVerticalBar {
  position: absolute;
  right: -4px;
  width: 4px;
  height: 100%;
  background: #660000;
  z-index: 1;
}

.active {
  background: #e0e0e0;
}

.mp-img {
  width: 120px;
  height: 180px;
  position: fixed;
  z-index: 10;
  color: #FFF;
  bottom: 0px;
  left: 0px;
  user-select: none;
}




.trainingCenterBigBox {
  display: flex;
  width: 94%;
  margin: 15px auto;
}

.closeIcon {
  /* width: 100%; */
  height: 20px;
}

.onTheLeftSideOfTheTrainingCenter {
  /*! flex: 1; */
  font-size: 14px;
  text-align: end;
  width: 183px;
  margin-right: 20px;
  cursor: pointer;

}

.theArrow {
  /* line-height: 40px; */
  font-size: 19px;
  margin-right: 35px;
  line-height: 1;
}

.trainingCentreOnTheRightSide {

  flex: 1;
}

.trainingCentreOnTheRightSide ul {
  display: flex;

  flex-wrap: wrap;
}

.trainingCentreOnTheRightSide ul li {
  /*! flex: 0 0 33%; */
  min-width: 0;
  margin-bottom: 17px;
  color: #868686;
  margin-right: 29px;
}

.trainingCentreOnTheRightSide ul li:hover {

  color: #ca1c1e;
  cursor: pointer;
}

.recommendThe {
  font-size: 20px;
  color: #000;
  font-weight: bold;
  border-bottom: 3px solid #6e0013;
  line-height: 28px;
  text-indent: 8px;
  height: 30px;
  margin-bottom: 16px;
}

.recommendedExperiment {
  height: 220px;
  border-bottom: 3px solid #6e0013;
}
.theExperimentalRecommendationIsAsFollows {
  margin-top: 21px;
}
</style>
